import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export function SpinnerLoader() {
  return <Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} />;
}
